import { useEffect, useState } from 'react';

export function useAfterFirstPaint(key: string | null = ''): boolean {
  const [previousKey, setPreviousKey] = useState(key);
  const [paintedKey, setPaintedKey] = useState<string | null>(null);

  if (previousKey !== key) {
    setPreviousKey(key);
    setPaintedKey(null);
  }

  useEffect(() => {
    if (key === null) return;

    let secondFrame: number | undefined;
    const firstFrame = requestAnimationFrame(() => {
      secondFrame = requestAnimationFrame(() => setPaintedKey(key));
    });

    return () => {
      cancelAnimationFrame(firstFrame);
      if (secondFrame !== undefined) cancelAnimationFrame(secondFrame);
    };
  }, [key]);

  return key !== null && previousKey === key && paintedKey === key;
}
